import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
//Components
import { Text } from "../../atoms/index";
import { PlusButton } from "../../molecules/index";
import theme from "../../../styles/theme.semantic";

const AgendaFeatured = ({
  className,
  dateContainerTextColor,
  dateContainerDay,
  dateContainerMonth,
  buttonBgColor,
  buttonTextColor,
  text,
  textColor,
  title,
  titleColor,
  date,
  dateColor,
  href,
  target
}) => {
  return (
    <a className={className} tabIndex={0} href={href} target={target}>
      <div className="row no-gutters">
        <div className="col-auto">
          <div className="date-container">
            <div className="date-content-container">
              <Text
                fontSize="56px"
                text={dateContainerDay}
                color={dateContainerTextColor}
                fontWeight="900"
                lineHeight="1"
              />
              <Text
                fontSize="30px"
                text={dateContainerMonth}
                color={dateContainerTextColor}
                fontWeight="300"
                textTransform="uppercase"
                lineHeight="1"
              />
              <PlusButton
                backgroundColor={buttonBgColor}
                size="30px"
                right="-16px"
                top="calc(50% - 15px)"
                zIndex="2"
                aria-hidden="true"
                tabIndex={-1}
                as="div"
              >
                <Text
                  fontSize="24px"
                  fontWeight="100"
                  color={buttonTextColor}
                  lineHeight="1"
                  text="+"
                />
              </PlusButton>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="content-container">
            <Text color={textColor} fontWeight="300" text={text} />
            <div className="title">
              <Text
                as="h3"
                size="large"
                text={title}
                color={titleColor}
                lineHeight="1.3"
              />
            </div>
            <Text
              textTransform="lowercase"
              color={dateColor}
              text={date}
              size="xSmall"
            />
          </div>
        </div>
      </div>
    </a>
  );
};

AgendaFeatured.propTypes = {
  className: PropTypes.string,
  dateContainerTextColor: PropTypes.string,
  dateContainerDay: PropTypes.string,
  dateContainerMonth: PropTypes.string,
  buttonBgColor: PropTypes.string,
  buttonTextColor: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  date: PropTypes.string,
  dateColor: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string
};

AgendaFeatured.defaultProps = {
  dateContainerDay: "00",
  dateContainerMonth: "MMM",
  text: "Texto",
  title: "Título",
  date: "data",
  target: "_blank",

  dateContainerTextColor:
    theme.components.agendaFeatured.dateContainerTextColor,
  buttonBgColor: theme.components.agendaFeatured.buttonBgColor,
  buttonTextColor: theme.components.agendaFeatured.buttonTextColor,
  textColor: theme.components.agendaFeatured.textColor,
  titleColor: theme.components.agendaFeatured.titleColor,
  dateColor: theme.components.agendaFeatured.dateColor
};

const AgendaFeaturedWithStyles = styled(AgendaFeatured)`
  display: block;
  text-decoration: none;
  margin-top: ${props => props.marginTop};
  .date-container {
    height: 120px;
    width: 120px;
    text-align: center;
    background-color: ${props => props.dateContainerBgColor};
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    border: 1px solid ${props => props.dateContainerBgColor};
    border-right: none;

    .date-content-container {
      z-index: 1;
    }

    :before {
      content: "";
      -webkit-transition: all 0.2s;
      -moz-transition: all 0.2s;
      -o-transition: all 0.2s;
      transition: all 0.2s;
      position: absolute;
      left: 0;
      width: 0;
      height: 100%;
      background-color: ${props => props.animationBgColor};
      z-index: 0;
    }
  }

  :hover {
    .date-container {
      p {
        color: ${props => props.textColorHover};
      }
      :before {
        width: 100%;
      }
      a {
        background-color: ${props => props.animationBgColor};
      }
    }
  }

  .content-container {
    border: 1px solid ${props => props.borderColor};
    padding: 30px;
    .title {
      margin: 10px 0;
    }
  }

  // Medium devices (tablets, less than 992px)
  @media (max-width: 991px) {
    margin-top: 50px;
  }
`;

AgendaFeaturedWithStyles.defaultProps = {
  dateContainerBgColor: theme.components.agendaFeatured.dateContainerBgColor,
  borderColor: theme.components.agendaFeatured.borderColor,
  textColorHover: theme.components.agendaFeatured.textColorHover,
  animationBgColor: theme.components.agendaFeatured.animationBgColor
};

export default AgendaFeaturedWithStyles;
